// extracted by mini-css-extract-plugin
export default {"container":"fees-input_container__IUv7K","input":"fees-input_input__eASh3"};